const InnovativeJuniorWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Selamat kepada Para Pemenang <b>Innovative Junior</b> di <b>IIT Challenge 2024</b>! Kompetisi ini dirancang untuk siswa tingkat dasar hingga menengah yang ditantang menciptakan solusi sederhana namun berdampak bagi masyarakat dengan pendekatan inovatif.
                </p>

                <p className="mb-4 font-semibold">Mengapa Kompetisi Ini Berharga?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Menumbuhkan Pola Pikir Inovatif:</b> Mendorong anak-anak berpikir kreatif sejak dini.</li>
                    <li><b>Latihan Presentasi Ide:</b> Membentuk kemampuan komunikasi dan percaya diri.</li>
                    <li><b>Fondasi untuk Masa Depan:</b> Membuka minat awal dalam bidang teknologi dan sains.</li>
                </ul>

                <p className="mb-3 font-semibold">🎖️ Pemenang Innovative Junior IIT Challenge 2024</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>
                        <p className="mb-2 font-semibold">🥇 Juara 1</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Arleen Eleanor Shilton</li>
                            <li className="font-semibold">• Michael Gerald Guowtama</li>
                            <li className="font-semibold">• Sidney Anyelir Situmeang</li>
                            <p><i>(SDK 3 Penabur)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥈 Juara 2 – Tim D6 ROBO TEAM</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Quentin Witio</li>
                            <li className="font-semibold">• Louis Josiah Gosal</li>
                            <li className="font-semibold">• Shayden Jade Antony</li>
                            <p><i>(SDK 6 Penabur)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥉 Juara 3 – Tim DSG Robotik</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Joan Mulyadi</li>
                            <li className="font-semibold">• Landon Keandre Noveanto</li>
                            <li className="font-semibold">• Nicholas Irawan</li>
                            <p><i>(SDK Penabur Gading Serpong)</i></p>
                        </ul>
                    </li>
                </ul>

                <p className="mb-4 font-semibold">🎁 Hadiah & Manfaat Eksklusif</p>
                <p className="mb-3">Para pemenang mendapatkan fasilitas untuk mendukung pengembangan skill teknologi mereka, termasuk:</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>
                <p className="mb-3">Hadiah dan manfaat ini dirancang untuk memberikan pengalaman belajar intensif dan peluang berkompetisi di tingkat nasional.</p>

                <p className="mb-2 font-semibold">📢 Ayo Jadi Generasi Inovator Muda!</p>
                <p className="mb-2">Mulailah berinovasi sejak dini! Siapkan ide terbaikmu dan bergabunglah di kompetisi berikutnya.</p>

                <p className="font-semibold">
                    📷 Lihat karya para peserta di Instagram <a className="text-blue-500" href="https://www.instagram.com/iitchallenge2024/" target="_blank">@iitchallenge2024</a>
                </p>
            </section>
        </div>
    )
}
export default InnovativeJuniorWinnersList